import {
  Button,
  Column,
  Form,
  Grid,
  Row,
  TextInput,
  Tile,
} from "carbon-components-react";
import jwtDecode from "jwt-decode";
import { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import Errors from "../../components/Errors";
import { loginAsAdmin } from "../../redux/actions/authenticationAction";
import { setAccountType } from "../../redux/actions/accountAction";

function LoginPage({ errors }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const [formContent, setFormContent] = useState({
    email: undefined,
    password: undefined,
  });

  const login = (e) => {
    e.preventDefault();
    dispatch(
      loginAsAdmin(
        { email: formContent.email, password: formContent.password },
        ({ data }) => {
          localStorage.setItem("accessToken", data.accessToken);

          try {
            const decoded = jwtDecode(data.accessToken);
            if (decoded.accountType) {
              dispatch(setAccountType(decoded.accountType));
            }
          } catch (error) {
            console.error("Failed to decode token", error);
          }

          history.push("/");
        },
      ),
    );
  };

  useEffect(() => {
    // check access token
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      // redirect
      history.push("/");
    }
  }, []);

  return (
    <Grid style={{ height: "100vh" }}>
      <Row style={{ alignItems: "center", height: "100vh" }}>
        <Column lg={{ span: 5 }}>
          <Tile>
            <h4 style={{ marginBottom: 20 }}>Login</h4>
            {errors && <Errors errors={errors} />}
            <Form onSubmit={login}>
              <TextInput
                autoFocus={true}
                onChange={(v) =>
                  setFormContent((_state) => ({
                    ..._state,
                    email: v.target.value,
                  }))
                }
                title="Email"
                labelText="Email"
                type="email"
                required={true}
                placeholder="input your email here"
                style={{ marginBottom: 20 }}
              />

              <TextInput
                title="Password"
                onChange={(v) =>
                  setFormContent((_state) => ({
                    ..._state,
                    password: v.target.value,
                  }))
                }
                labelText="Password"
                type="password"
                required={true}
                placeholder="input your password here"
                style={{ marginBottom: 20 }}
              />

              <Button type="submit">Login</Button>
            </Form>
          </Tile>
        </Column>
      </Row>
    </Grid>
  );
}

const mapStateToProps = (state) => {
  return {
    errors: state.uxReducer.errors,
  };
};

export default connect(mapStateToProps)(LoginPage);
